module.exports = __webpack_public_path__ + "static/media/uk.09a21a45.png";